import { EnumLanguage } from '@libs/constants';

import { EnumLegalPageRoute } from './legal-pages.interface';


/**------------------------------------------------------
 * Legal Pages Titles
 */
export const LEGAL_PAGE_TITLES_DATA: Partial<Record<EnumLanguage, Record<EnumLegalPageRoute, string>>> = {
	[EnumLanguage.EN] : {
		[EnumLegalPageRoute.Imprint] 			: 'Imprint / Legal Notice',
		[EnumLegalPageRoute.CookiesUsage] 		: 'Cookies Usage',
		[EnumLegalPageRoute.PrivacyPolicy] 		: 'Privacy Policy',
		[EnumLegalPageRoute.TermsOfUse] 		: 'Terms Of Use',
		[EnumLegalPageRoute.AffiliateTerms] 	: 'Affiliate Terms',
		[EnumLegalPageRoute.CancellationPolicy] : 'Cancellation Policy'
	},
	[EnumLanguage.DE] : {
		[EnumLegalPageRoute.Imprint] 			: 'Impressum / Rechtliche Hinweise',
		[EnumLegalPageRoute.CookiesUsage] 		: 'Cookie-Nutzung',
		[EnumLegalPageRoute.PrivacyPolicy] 		: 'Datenschutzerklärung',
		[EnumLegalPageRoute.TermsOfUse] 		: 'Nutzungsbedingungen',
		[EnumLegalPageRoute.AffiliateTerms] 	: 'Affiliate-Bedingungen',
		[EnumLegalPageRoute.CancellationPolicy] : 'Widerrufsbelehrung'
	}
};
